import { Box } from "@chakra-ui/react";
import { FC } from "react";

import {
  FeatureCard,
  FeatureGrid,
  PageCta,
  PageHero,
  PageSection,
  SectionHeading,
  usePageTitle,
} from "./components";

export const VoorGemeenten: FC = () => {
  usePageTitle("BROSTAR voor Gemeenten");

  return (
    <Box>
      <PageHero
        title="BROSTAR voor Gemeenten"
        subtitle="Als gemeente bent u bronhouder voor grondwatermonitoring. BROSTAR helpt u uw wettelijke aanleververplichting aan de BRO eenvoudig en foutloos na te komen."
      />

      <PageSection>
        <SectionHeading>Waarom BROSTAR voor uw gemeente?</SectionHeading>
        Gemeenten hebben een breed takenpakket, met een beperkte bezetting. Wanneer het aantal
        applicaties binnen een gemeente groeit, wordt de beheerlast en technische afhankelijkheid
        steeds groter, terwijl de capaciteit om dit te beheren vaak niet mee kan groeien. Er moet
        documentatie worden bijgehouden, omdat werkprocessen soms erg complex worden. Binnen BROSTAR
        geloven we dat dit niet nodig is, en dat het aanleveren van grondwaterdata aan de BRO zo
        eenvoudig mogelijk moet zijn. We bieden een gebruiksvriendelijke oplossing die u helpt om uw
        aanleververplichting na te komen, zonder dat u zich zorgen hoeft te maken over technische
        details of complexe processen. We denken graag mee over de beste manier om BROSTAR in te
        zetten binnen uw gemeente, zodat u zich kunt richten op uw kerntaken, terwijl wij zorgen
        voor een soepele aanlevering aan de BRO.
        <FeatureGrid>
          <FeatureCard title="In de praktijk: gemeente Rotterdam">
            Voor de gemeente Rotterdam verstuurt BROSTAR, vanuit ons dataplatform Lizard waar de
            validatie via ArtDiver plaatsvindt, alle grondwaterstanden naar de Basisregistratie
            Ondergrond. Ook correcties sturen we automatisch mee zodra nieuwe of gewijzigde gegevens
            beschikbaar komen.
          </FeatureCard>
          <FeatureCard title="Wettelijke verplichting eenvoudig nakomen">
            Gemeenten zijn verplicht grondwatermeetgegevens aan te leveren aan de Basisregistratie
            Ondergrond. Echter is er binnen een gemeente vaak een beperkte capaciteit om zelf
            software te beheren of ontwikkelen. BROSTAR biedt een laagdrempelige methode om
            BRO-compliant te worden, zonder afhankelijk te zijn van verschillende leveranciers.
          </FeatureCard>
          <FeatureCard title="Grondwatermonitoring zonder gedoe">
            De BRO is een complex systeem, echter bent u via BROSTAR in staat om uw gehele meetnet
            te beheren met enkel een aantal formulieren. Zo kunt u in feiten met een groep Excel en
            CSV-bestanden aan al uw eisen voldoen, zonder een complex systeem te hoeven beheren.
          </FeatureCard>
          <FeatureCard title="Eén software product voor al uw BRO-registraties">
            Als gemeente heeft u te maken met verschillende BRO-domeinen, grondwatergebruik,
            grondwatermonitoring en boringen vinden allemaal plaats binnen uw werkgebied. BROSTAR
            werkt aan een omgeving waarbinnen u al deze verschillende registraties kunt beheren,
            zonder dat u voor elk domein een ander systeem nodig heeft.
          </FeatureCard>
          <FeatureCard title="Eenvoudig in te zetten">
            Hoewel het mogelijk is een automatische koppeling te bouwen, is het altijd mogelijk om
            BROSTAR voor een deel van uw verantwoordelijkheden in te zetten. Zo kan het zijn dat uw
            leverancier niet in staat is correcties of verwijder berichten te sturen, met BROSTAR
            heeft u zelf altijd een laagdrempelige manier om dit soort berichten te versturen,
            zonder dat u hiervoor een koppeling hoeft te bouwen.
          </FeatureCard>
          <FeatureCard title="Eenvoudig te leren">
            BROSTAR heeft een beperkte set aan functionaliteiten, en hierdoor is het ook eenvoudig
            om te leren. Nieuwe medewerkers kunnen zonder veel moeite aan de slag, en na enkele
            keren de applicatie gebruikt te hebben zullen ze er al snel wegwijs in zijn. Daarnaast
            is onze servicedesk altijd beschikbaar om vragen te beantwoorden, en kunnen we ook
            trainingen verzorgen wanneer hier behoefte aan is.
          </FeatureCard>
          <FeatureCard title="Gedeelde oplossing, voor langdurige samenwerking">
            Meerdere organisaties geloven in BROSTAR, hierdoor is de levensduur van de applicatie
            gewaarborgd. We blijven continu doorontwikkelen, en staan altijd open voor feedback en
            suggesties.
          </FeatureCard>
        </FeatureGrid>
      </PageSection>

      <PageCta
        title="Maak uw gemeente BRO-compliant"
        body="BROSTAR helpt gemeenten in heel Nederland bij het nakomen van hun BRO-aanleververplichting. Vraag vandaag nog een demo aan."
      />
    </Box>
  );
};
